import {
    baseUrl
} from '@/config/env';
import request from '@/router/axios';
import {
    parseParam
} from '@/util/util';


export const findCreditList = (params) => {
    params = parseParam(params);
    return request({
        url: `${baseUrl}/joins-invoice-system/v1/credit/list?` + params,
        method: 'GET',
    })
};
export const findCreditListDownloadExcel = (params) => {
    params = parseParam(params);
    return request({
        url: `${baseUrl}/joins-invoice-system/v1/credit/excel?` + params,
        method: 'GET',
    })
};
export const InvoiceSystemV2Statistics = (params) => { //商户库存云监控列表
    params = parseParam(params);
    return request({
        url: `${baseUrl}/joins-invoice-system/v2/delivery-order/shop-statistics?` + params,
        method: 'GET',
    })
};
export const InvoiceSystemV2StatisticsDownload = (params) => { //商户库存云监控列表
    params = parseParam(params);
    return request({
        url: `${baseUrl}/joins-invoice-system/v2/statistics/downloadExcel?` + params,
        method: 'GET',
    })
};

export const findStockMonitorDetail = (params) => {
    params = parseParam(params);
    return request({
        url: `${baseUrl}/joins-invoice-system/v1/stock/detail?` + params,
        method: 'GET',
    })
};
export const InvoiceSystemV2StatisticsDetail = (id, params) => { //商户库存云监控详情
    params = parseParam(params);
    return request({
        url: `${baseUrl}/joins-invoice-system/v2/delivery-order/shop-statistics/${id}?` + params,
        method: 'GET',
    })
};
export const InvoiceSystemV2StatisticsDetailDownload = (id, params) => { //商户库存云监控详情
    params = parseParam(params);
    return request({
        url: `${baseUrl}/joins-invoice-system/v2/statistics/downloadExcel/${id}?` + params,
        method: 'GET',
    })
};
// 查看商品库存详情
export const findStockMonitorDetailDownloadExcel = (id,shopId) => {
    return request({
        url: `${baseUrl}/joins-invoice-system/v2/delivery-order/inventory-check/${id}`+`?shopId=${shopId}`,
        method: 'GET',
    })
};
export const updateCredit = (id, params) => {
    params = parseParam(params);
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/shop/updateCredit/${id}?` + params,
        method: 'GET',
    })
};